import { useContext } from 'react'
import { ScheduleDetailsContext } from './scheduleDetailsContextValue.js'

export function useScheduleDetails() {
  const ctx = useContext(ScheduleDetailsContext)
  if (!ctx) {
    throw new Error('useScheduleDetails must be used within ScheduleDetailsProvider')
  }
  return ctx
}

/** For trees that may render outside the provider (tests, isolated stories). */
export function useScheduleDetailsOptional() {
  return useContext(ScheduleDetailsContext)
}
